import { I2PEnvironment } from '@price-for-profit/micro-services';
import { Dashboard } from '@mui/icons-material';

const routeConfig: EnvironmentNavigation[] = [
    {
        application: {
            applicationName: 'Drive Account',
            env: {
                local: {
                    applicationId: 'd188f4d2-3ef5-4a7d-8366-bf0c3dbd7037',
                    deployedUrl: 'https://localhost:5001/apps/account',
                },
                dev: {
                    applicationId: 'd188f4d2-3ef5-4a7d-8366-bf0c3dbd7037',
                    deployedUrl: 'https://bwg-jjh.dev.insight2profit.com/apps/account',
                },
                sandbox: {
                    applicationId: '48599a2d-4022-4b8a-bc24-d30402b500e5',
                    deployedUrl: 'https://bwg-jjh.sandbox.insight2profit.com/apps/account',
                },
                prod: {
                    applicationId: '8aa5f882-f3b9-49c9-957c-694a4d2071a1',
                    deployedUrl: 'https://bwg-jjh.insight2profit.com/apps/account',
                },
            },
        },
        links: [
            {
                title: 'Analytics Dashboard',
                url: '/analytics',
                icon: <Dashboard sx={{ color: 'primary.main' }} />,
            },
        ],
    },
];

interface NavigationLink {
    title: string;
    url: string;
    icon?: JSX.Element;
}

interface EnvironmentNavigation {
    application: {
        applicationName: string;
        env: Record<Exclude<I2PEnvironment, 'model'> | 'local', { applicationId: string; deployedUrl: string }>;
    };
    links: NavigationLink[];
}

interface DriveAccountNavigation {
    application: {
        applicationId: string;
        applicationName: string;
        deployedUrl: string;
    };
    links: NavigationLink[];
    local?: boolean;
}

interface BuildDriveAccountNavigationProps {
    applicationId: string;
    environment: Exclude<I2PEnvironment, 'model'>;
    useLocal?: boolean;
}

export function buildDriveAccountNavigation({
    applicationId,
    environment,
    useLocal,
}: BuildDriveAccountNavigationProps): DriveAccountNavigation[] {
    const localEnvironment = environment === 'dev' && useLocal ? 'local' : environment;

    return routeConfig.map<DriveAccountNavigation>(({ links, application }) => {
        const envConfig = application.env[localEnvironment];
        return {
            application: {
                applicationName: application.applicationName,
                ...envConfig,
            },
            links,
            local: applicationId === envConfig.applicationId,
        };
    });
}

export const showHamburger = routeConfig.length > 1;
